import { CircularProgress } from '@material-ui/core'
import React, { Suspense, useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateRoutes from './constants/routes/PrivateRoutes'
import { RoutesTemplate } from './constants/routes/RoutesTemplate'
import NotFound from './pages/NotFound'
import { useAdminUser } from './services/reduxToolkit/adminUserLogin/selectors';
import { useSelector } from 'react-redux';
import { rdb } from "./services/firebase"
import AudioComponent from './components/Audio/AudioComponent';
import { AllRoutes } from './constants/routes/AllRoutes'
import { getStreamUrl } from './services/zenoStream';

export default function AppIndex() {
  const user = useSelector(useAdminUser);
  const [ShowAudio, setShowAudio] = useState(true)
  const [StreamID, setStreamID] = useState<any>({});
  const [defaultUrl, setDefaultUrl] = useState<string>("");
    const streamRef = rdb.ref().child('/streamID');

    useEffect(() => {
        getStreamUrl().then(setDefaultUrl);
    }, [])

    useEffect(() => {
        const listener = streamRef.on("value", (id: any) => {
            if (id?.val) setStreamID(id.val())
        })
        if(window.location.pathname.includes(AllRoutes.admin)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminChat)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminDashboard)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminInfo)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminProgramming)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminPublish)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminSponsors)) setShowAudio(false)
        if(window.location.pathname.includes(AllRoutes.adminUsers)) setShowAudio(false)

        return () => {
            if (listener) {
                streamRef.off("value", listener)
            }
        }
    }, [])

    const streamId = StreamID?.id || defaultUrl || undefined;

  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ width: "100%", height: "100vh", boxSizing: "border-box", display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center" }}><CircularProgress color="secondary" /></div>}>
        <Routes>
            {
              RoutesTemplate.map(({routes, template, auth, secondaryAuth}) => {
                return routes.map((route) => (
                  <Route
                    path={route.path}
                    key={route.path}
                    element={<PrivateRoutes
                      route={route}
                      path={route.path}
                      template={template}
                      auth={auth}
                      altAuth={secondaryAuth}
                      component={route.component}
                      redirect={route.to}
                      userData={user}
                    />}
                  />
                ))
              })
            }
            <Route path="/" element={<NotFound />} />
        </Routes>
      </Suspense>
      {ShowAudio && <AudioComponent StreamID={{ id: streamId }} />}
    </BrowserRouter>
  )
}
